@app.controller 'SSOController', (currentUser, $location, ssoService) ->
  @state = $location.search().state
  @showForm = false
  if currentUser && !ssoService.isAmazon()
    ssoService.signAndRedirect(@state)
  else
    @showForm = true
  this
